import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import sorro from "../../assets/image/stella/sorro.png";

const faqData = [
    {
        id: 1,
        question: "¿Qué es Stella TV y para qué sirve?",
        answer: "Stella TV es una aplicación de suscripción que permite acceder a más de mil canales de televisión en vivo. Además, ofrece películas, series, anime y contenido para adultos (+18). Este servicio está disponible tanto en celulares como en smart TVs con sistema Android."
    },
    {
        id: 2,
        question: "¿Qué dispositivos son compatibles con StellaTV?",
        answer: "Actualmente, la aplicación es compatible únicamente con dispositivos que operen con el sistema Android, como: Celulares, tabletas, Fire TV Stick, smart TVs con Android, TV Box, Chromecast de 4ta generación y emuladores de Android para PC con Windows o macOS."
    },
    {
        id: 3,
        question: "¿En cuántas pantallas se puede ver?",
        answer: "Stella TV te ofrece 3 pantallas simultáneamente. Podrás ver en 3 dispositivos al mismo tiempo sin problema algunos lo podrás hacer en la misma casa o en diferentes lugares (misma o diferente IP)."
    },
    {
        id: 4,
        question: "¿Cómo instalar Stella TV en una PC o MAC?",
        answer: "La instalación solo es posible en computadoras que cuenten con un emulador de Android. Sin este emulador, no es posible instalar la aplicación de Stella TV."
    },
    {
        id: 5,
        question: "¿Brindan un demo de prueba?",
        answer: "Sí, puedes solicitar un demo para verificar la estabilidad y el contenido antes de contratar el servicio completo."
    },
    {
        id: 6,
        question: "¿Se puede instalar en un iPhone?",
        answer: "No, esta aplicación solo puede instalarse en dispositivos móviles con Android. Actualmente, la lista IPTV que funcionaba en iOS está deshabilitada, por lo que no es posible ver el contenido en iOS."
    },
    {
        id: 7,
        question: "¿Se puede ver en tv Samsung o LG?",
        answer: "Los televisores de marcas como Samsung o LG no cuentan con sistema operativo Android, por lo que no se puede instalar la aplicación de MagisTV. En estos casos, se recomienda adquirir un TV Box o Firestick para adaptarlo a su smart TV de estas marcas."
    },

];

const AccordionItem = ({ i, expanded, setExpanded, question, answer }) => {
    const isOpen = i === expanded;

    return (
        <motion.div
            initial={false}
            className="mb-4 overflow-hidden rounded-lg bg-white  shadow-sm"
        >
            {/* Cabecera (Pregunta) */}
            <motion.header
                initial={false}
                onClick={() => setExpanded(isOpen ? false : i)}
                className={`flex cursor-pointer items-center text-black justify-between p-6 transition-colors duration-300 ${
                    isOpen
                        ? "bg-gradient-to-r from-orange-500 to-red-600 text-white" // Estilo Activo (Naranja)
                        : " text-gray-900 hover:bg-gray-50" // Estilo Inactivo (Blanco)
                }`}
            >
                <h3 className={`text-lg font-bold sm:text-xl font-sans ${
                    isOpen
                        ? "text-white" // Estilo Activo (Naranja)
                        : " text-gray-900 hover:text-[#eeb500]" // Estilo Inactivo (Blanco)
                }`} >{question}</h3>

                {/* Icono de flecha animado */}
                <motion.div
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </motion.div>
            </motion.header>

            {/* Cuerpo (Respuesta) con Framer Motion */}
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.section
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { opacity: 1, height: "auto" },
                            collapsed: { opacity: 0, height: 0 }
                        }}
                        transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                    >
                        <div className="border-t border-gray-100 bg-white p-6 text-gray-700 leading-relaxed">
                            {answer}
                        </div>
                    </motion.section>
                )}
            </AnimatePresence>
        </motion.div>
    );
};

// 3. Componente Principal de la Sección
export default function Question() {
    const [expanded, setExpanded] = useState(0);

    return (
        <div className="min-h-screen bg-[#111] px-6 py-20 text-white font-sans" id="fag">
            <div className="mx-auto max-w-7xl">
                <div className="grid gap-12 lg:grid-cols-2 lg:gap-8">

                    {/* Columna Izquierda: Textos e Imagen */}
                    <div className="flex flex-col justify-start">
                        <span className="mb-2 text-yellow-500 font-bold uppercase tracking-wider">FAQ</span>
                        <h2 className="mb-6 text-5xl font-extrabold leading-tight uppercase">
                            Preguntas <br /> Frecuentes
                        </h2>
                        <p className="mb-8 text-gray-400 max-w-md text-lg">
                            Aquí encontrarás respuestas a las preguntas más comunes sobre esta aplicación, como:
                            <span className="text-white font-semibold"> ¿cómo renovar StellaTV? ¿cómo adquirir una cuenta?</span> entre otras.
                        </p>
                        <p className="mb-12 text-gray-400 text-lg">
                            Esperamos responder a todas ellas.
                        </p>

                        {/* Aquí va tu imagen del zorro */}
                        <div className="relative mt-auto w-full max-w-xs mx-auto lg:mx-0">
                            {/* Reemplaza src con tu importación real */}
                            <img
                                src={sorro}
                                alt="Mascota pensando"
                                className="w-full object-contain drop-shadow-2xl"
                            />
                        </div>
                    </div>

                    {/* Columna Derecha: Acordeón */}
                    <div className="flex flex-col justify-center">
                        {faqData.map((item) => (
                            <AccordionItem
                                key={item.id}
                                i={item.id}
                                expanded={expanded}
                                setExpanded={setExpanded}
                                question={item.question}
                                answer={item.answer}
                            />
                        ))}
                        <div>
                            <p>StellaTV usuario y contraseña gratis, generador cuentas Stella TV | Web oficial de Stella TV 2025</p>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
}